module.exports = __webpack_public_path__ + "static/img/winter_jianjiePic.7134776a.png";